module.exports = __webpack_public_path__ + "img/SEC logo red-white.98a5db16.svg";